import { ReactElement } from 'react';
import EquipmentForm from './EquipmentForm';

interface Manufacturer {
  id: string;
  name: string;
  notes?: string;
}

interface EditEquipmentFormProps {
  equipmentType: string;
  equipment: any;
  manufacturers: Manufacturer[];
  onSuccess: () => void;
  onCancel: () => void;
}

const EditEquipmentForm = (props: EditEquipmentFormProps): ReactElement => {
  return <EquipmentForm mode="edit" {...props} />;
};

export default EditEquipmentForm;
